export const clamp = (value: number, min: number, max: number): number => Math.min(max, Math.max(min, value))

export const lerp = (from: number, to: number, amount: number): number => from + (to - from) * amount

export const random = (min: number, max: number): number => min + Math.random() * (max - min)

export const smoothstep = (edge0: number, edge1: number, value: number): number => {
    const t = clamp((value - edge0) / (edge1 - edge0), 0, 1)

    return t * t * (3 - 2 * t)
}

export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - clamp(t, 0, 1), 3)

export const easeInOutSine = (t: number): number => -(Math.cos(Math.PI * clamp(t, 0, 1)) - 1) / 2

// Cubic Hermite curve: lands on `to` at `duration` while matching both start and end speeds.
export const hermite = (from: number, to: number, startSpeed: number, endSpeed: number, duration: number, time: number): number => {
    const s = clamp(time / duration, 0, 1)
    const s2 = s * s
    const s3 = s2 * s

    return (2 * s3 - 3 * s2 + 1) * from
        + (s3 - 2 * s2 + s) * duration * startSpeed
        + (-2 * s3 + 3 * s2) * to
        + (s3 - s2) * duration * endSpeed
}

// Soft pop used whenever a file appears: 0.6, past 1.05, settling on 1.
export const popScale = (progress: number): number => {
    const p = clamp(progress, 0, 1)

    if (p < 0.6) return lerp(0.6, 1.05, easeOutCubic(p / 0.6))

    return lerp(1.05, 1, easeInOutSine((p - 0.6) / 0.4))
}
